import { BlitsError } from "./blits.error";

export class NotFoundError extends BlitsError {

    static CODE = "not-found_error";

    constructor(message: string, public details?: string) {
        super(NotFoundError.CODE, message || `The resource that you are looking for was not found.`);
    }
}